module.exports = __webpack_public_path__ + "img/CT.Bridges.Substructure.Hammerhead_Pier.Reinforced_Concrete.94821363.png";